import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import DistrictForm from "./DistrictForm";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import useDeleteDistrict from "./hooks/useDeleteDistrict";
import useEmployeeOptions from "./hooks/useEmployeeOptions";
import { useOfficeHierarchyChildByTypeId } from "../hooks/useOfficeHierarchyChildByTypeId";
import {
  addStateDistrict,
  selectedRowsStateDistrict,
  setFilterTextDistrict,
  editStateDistrict,
  rowForEditStateDistrict,
  setCheckStatusStateDistrict,
  disableButtonStateDistrict,
  rowEditIdStateDistrict,
  setHiddenColumnStateDistrict,
  setLinkStateDistrict,
  setButtonLinkTextStateDistrict,
  setHierarchyIdStateDistrict,
  setDescriptionDistrictState,
  codeIdDistrict,
  districtShowState,
} from "../../OfficeHierarchy/District/atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import {
  getHierarchyType,
  viewSetIdStates,
  viewSetShowModalState,
} from "./../atoms/atoms";
// import OfficeHierarchyExpandedRow from "../../OfficeHierarchy/OfficeHierarchyExpandedRow";

const DistrictTable = ({ districtRowData, onClickOfficeHierarchyName }) => {
  //Hooks Call
  const { data, isFetching } = useOfficeHierarchyChildByTypeId(
    "District",
    districtRowData.idC
  );
  const [id, setId] = useRecoilState(viewSetIdStates);
  const [showModal, setShowModal] = useRecoilState(viewSetShowModalState);
  const BulkDeleteDistrict = useDeleteDistrict();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateDistrict);
  const [, setRowForEdit] = useRecoilState(rowForEditStateDistrict);
  const [filterText, setFilterText] = useRecoilState(setFilterTextDistrict);
  const [editRowId, setEditRowId] = useRecoilState(rowEditIdStateDistrict);
  const [actionEditState, setActionEditState] =
    useRecoilState(editStateDistrict);
  const [disabledButton, setDisabledButton] = useRecoilState(
    disableButtonStateDistrict
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateDistrict
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [, setCodeId] = useRecoilState(codeIdDistrict);
  const [, setType] = useRecoilState(getHierarchyType);
  const [, setCheckStatus] = useRecoilState(setCheckStatusStateDistrict);
  const [hideColumn, sethideColumn] = useRecoilState(
    setHiddenColumnStateDistrict
  );
  const [, setButtonTextLinkState] = useRecoilState(
    setButtonLinkTextStateDistrict
  );
  const [, setButtonLinkState] = useRecoilState(setLinkStateDistrict);
  const [, setHierarchyId] = useRecoilState(setHierarchyIdStateDistrict);
  const [, setDescription] = useRecoilState(setDescriptionDistrictState);
  //Local States
  const [, setEmpTypeIsExistState] = useState(false);
  const [, setEmpTypeDataIsChange] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [displayNote] = useState(false);
  const [, setEdit] = useState(false);
  const [districtFilteredData, setDistrictFilteredData] = useState([]);
  const employeeList = useEmployeeOptions();

  const viewPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_district_view;
  const deletePermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_district_delete;

  const editPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_district_edit;
  const addPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_district_add;
  const userPermissions = useRecoilValue(permissionsSelector);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent != "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setDistrictFilteredData(result);
          setButtonTextLinkState(recordIdFromRecent.subModuleName);
          if (
            recordIdFromRecent.subModuleName === "Add" ||
            recordIdFromRecent.subModuleName === "Edit"
          ) {
            setType(recordIdFromRecent.selectedType);
            setHierarchyId(recordIdFromRecent.hierarchyId);
            setDescription(recordIdFromRecent.description);
            setCodeId(recordIdFromRecent.codeId);
            setActionAddState(true);
            setButtonLinkState(true);
          }

          history.replace();
        });
      } catch (error) {}
    } else {
      setButtonLinkState(false);
      setButtonTextLinkState("");
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
    setDisabledButton(false);
    setDistrictFilteredData([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleEditButton = (rowData) => {
    setDistrictFilteredData([]);
    setRowForEdit(rowData);
    setEditRowId(rowData.districtId);
    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    sethideColumn(true);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.districtId);
    BulkDeleteDistrict(ids);
    setActionEditState(false);
    setActionAddState(false);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Districts" : "District"
    } ?`}</div>
  );

  const matColumns = [
    {
      title: "District Name",
      field: "districtName",
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => onClickOfficeHierarchyName(rowdata)}
          >
            <span className="blueAndBold underline ">
              {rowdata.officeHierarchyName}
            </span>
          </div>
        );
      },
      cellStyle: {
        textAlign: "left",
        width: "30%",
        fontSize: "12px",
      },
    },

    {
      title: "Type",
      field: "Type",
      hidden: hideColumn,
      render: (rowData) => {
        return <div className="font-sans  mr-4 text-xs">{rowData.type}</div>;
      },
    },
    {
      title: "Code",
      field: "hierarchyCode",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans text-left mr-4 text-xs">
            {rowData.hierarchyCode}
          </div>
        );
      },
    },
    {
      title: "Manager",
      field: "regionManager",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.managerName}</div>
        );
      },
    },
    {
      title: "Is Active",
      field: "status",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={rowData.isActive ? true : false}
                //   onClick={(e) => {
                //     setIsChecked(e.target.checked);
                //     handleCheckBox(e);
                //   }
                // }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Record Type",
      field: "recordType",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.recordType}</div>
        );
      },
    },
    // {
    //   title: "Action/s",
    //   align: "center",
    //   render: (rowData) => {
    //     return (
    //       <div className="grid grid-col-1 justify-items-center mr-6">
    //         {userPermissions.includes(editPermission) ? (
    //           <Button
    //             disabled={disabledButton || selectedRows.length > 0}
    //             className={
    //               disabledButton || selectedRows.length > 0
    //                 ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
    //                : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
    //             }
    //             onClickFunction={() => {
    //               setActionEditState(true);
    //               setButtonLinkState(false);
    //               handleEditButton(
    //                 //Removing tableData in Material Table
    //                 rowData
    //               );
    //               // setId(rowData.idC);

    //               // setShowModal(true);
    //             }}
    //           >
    //             <PencilSquareIcon className="h-4 w-4" />
    //             <div>Edit</div>
    //           </Button>
    //         ): (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  //Filters
  const filteredItems = data ? data : [];
  return (
    <div className="">
      <div className="">
        {!actionAddState && !actionEditState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                {/* <div className="font-bold text-primary text-xl uppercase mx-4 ">
                  {" "}
                  <h1>District</h1>{" "}
                </div> */}
                <div className="flex justify-between text-xs items-center w-full px-4 mt-2">
                  <div className="">
                    {/* <TableFilters
                      filterText={setFilterText}
                      moduleDetails="District Name"
                      textInputName="DistrictName"
                      disabledButton={disabledButton || selectedRows.length > 0}
                    ></TableFilters> */}
                  </div>
                  <div className="">
                    {/* {userPermissions.includes(addPermission) ? (
                      <AddButton
                        buttonText="New District"
                        className={
                          selectedRows.length > 0 ||
                          actionEditState ||
                          disabledButton
                            ? "opacity-50"
                           : "opacity-100"
                        }
                        onClick={() => {
                          setActionAddState(!actionAddState);
                          setButtonLinkState(false);
                        }}
                        disabled={disabledButton || selectedRows.length > 0}
                      />
                    ): (
                      ""
                    )} */}
                  </div>
                </div>
                <div>
                  {/* {userPermissions.includes(deletePermission) &&
                  !displayNote ? (
                    <div className="text-secondary italic text-xs3 mt-2 mx-4">
                      {!actionEditState ? (
                        <div>
                          <p className="font-bold italic inline-block mr-1">
                            Note:{" "}
                          </p>
                          Tick the box to deactivate some data.
                        </div>
                      ): (
                        <div></div>
                      )}
                    </div>
                  ): (
                    ""
                  )} */}
                </div>
                <div className="p-4">
                  <MaterialExTable
                    columns={matColumns}
                    data={
                      data
                      // ? districtFilteredData.length > 0
                      //   ? districtFilteredData
                      //  : filterText === ""
                      //   ? data.map((data) => ({ ...data }))
                      //  : filteredItems
                      //: []
                    }
                    options={{
                      toolbar: false,
                      showTitle: false,
                    }}
                    // detailPanel={(rowData) => {
                    //   return (
                    //     <div className="w-full p-2 borderContainer border-quinary border-l-2 bg-gray-100">
                    //       <DistrictExpandedRow
                    //         data={rowData}
                    //         editRow={actionEditState}
                    //         // HandleModalShow={HandleModalShow}
                    //       />
                    //     </div>
                    //   );
                    // }}
                    // selection={
                    //   !actionEditState &&
                    //   userPermissions.includes(deletePermission)
                    // }
                    setOpenModal={setOpenModalDelete}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    isDeactivate={true}
                    isLoading={isFetching}
                  />
                </div>
              </div>
            </div>
            <ConfirmBoxDelete
              ModalTitle="Deactivate District"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        )}
        {actionAddState && (
          <div className="px-4 py-2">
            <DistrictForm employeeList={employeeList} />
          </div>
        )}
        {actionEditState && (
          <div className="px-4 py-2">
            <DistrictForm employeeList={employeeList} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DistrictTable;
